import styled from 'styled-components';
import { Container } from 'components/domain/container';

export const FdrAdditionalProductInformation = styled(Container)(
  ({ theme: { media, colors } }) => ({
    display: 'grid',
    gridTemplateColumns: '100%',
    gap: '40px',
    marginTop: '30px',
    marginBottom: '30px',
    [media.tablet]: {
      gridTemplateColumns: '1fr 1fr',
      gap: '20px',
      marginTop: '70px',
      marginBottom: '70px',
    },
    '.info-section-wrapper': {
      display: 'flex',
      flexDirection: 'column',
      '.image': {
        objectFit: 'contain',
        backgroundColor: colors.paperGrey,
      },
    },
  })
);

export const FdrSectionWrapper = styled.div(({ theme: { space } }) => ({
  flexBasis: '100%',
  paddingLeft: space[4],
  paddingRight: space[4],
  border: '1px solid black',
}));

export const FdrPdfLinks = styled.div(({ theme: { space, text, colors } }) => ({
  padding: `${space[4]} 0`,
  '.pdf-link': {
    ...text.groupHeading,
    display: 'flex',
    alignItems: 'center',
    gap: space[2],
    color: colors.primary,
    marginBottom: space[2],
    '.icon': {
      height: '30px',
      width: '26px',
      flexShrink: 0,
    },
  },
  '.print-pdf-title': {
    ...text.groupHeading,
    marginBottom: space[3],
  },
}));

export const FdrInfoSectionWrapper = styled.div(
  ({ theme: { space, text, fontSizes, colors } }) => ({
    paddingTop: space[5],
    paddingBottom: space[5],
    ul: {
      listStyle: 'disc',
      paddingLeft: space[3],
    },
    '&:not(:last-child)': {
      borderBottom: '1px solid black',
    },
    '.info-pair-title, .section-name': {
      ...text.groupHeading,
      marginRight: space[2],
    },
    p: {
      marginBottom: space[2],
    },
    b: {
      ...text.groupHeading,
      display: 'inline',
    },
    a: {
      fontSize: fontSizes[0],
      color: colors.primary,
      fontWeight: 900,
    },
  })
);
